"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_1 = require("./styled");
exports.Button = function (_a) {
    var onClick = _a.onClick, children = _a.children, title = _a.title, _b = _a.variant, variant = _b === void 0 ? "primary" : _b, _c = _a.sx, sx = _c === void 0 ? {} : _c, id = _a.id, disabled = _a.disabled, _d = _a.isLoading, isLoading = _d === void 0 ? false : _d, _e = _a.fullWidth, fullWidth = _e === void 0 ? false : _e;
    return (react_1.default.createElement(styled_1.ExtendedButtonUI, { id: id, "data-testid": id, variant: variant, onClick: onClick, title: title, sx: __assign({ width: fullWidth ? "100%" : "auto" }, sx), disabled: disabled || isLoading, isLoading: isLoading }, children));
};
